"use client";
import Image from "next/image";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import DropDown from "./DropDown/DropDown";
import NavbarItems from "./NavbarItems/NavbarItems";
import { useEffect, useState } from "react";

function Navbar({
  openSidebar,
  sidebar,
  setSidebarPosition,
}: {
  openSidebar: (callback?: any) => void;
  sidebar: boolean;
  setSidebarPosition?: (pos: "left" | "right") => void;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const isMcaOrMba = pathname?.includes("/department/mca") || pathname?.includes("/department/mba");
  const [isScrolled, setIsScrolled] = useState(false);

  return (
    <>
      {/* First Header */}
      <section
        style={{ backgroundColor: "#2884CA" }}
        className={`relative block transition-all ease-in-out duration-500 overflow-hidden text-white ${
          isScrolled ? "-mt-12 opacity-0" : "mt-0 opacity-100"
        }`}
      >
        {/* Desktop View */}
        <div className="hidden lg:flex items-center w-full h-12 border-b border-b-[#1e6fa8]">
          <div className="flex items-center justify-between w-full container-padding max-w-[95%] mx-auto text-white">
            <div className="flex items-center justify-center space-x-6">
              <Link
                href={"mailto:canarait@gmail.com"}
                className="text-[14px] xl:text-[16px] text-white font-bold font-poppins hover:text-blue-100 transition-colors ease-in-out duration-300"
              >
                Email: canarait@gmail.com
              </Link>
              <div className="flex gap-1">
                <p className="text-[14px] xl:text-[16px] text-white font-bold font-poppins transition-colors ease-in-out duration-300">Phone:</p>
                <Link
                  href={"tel:+918792727001"}
                  className="text-[14px] xl:text-[16px] text-white font-bold font-poppins hover:text-blue-100 transition-colors ease-in-out duration-300"
                >
                  + 91 8792727001
                </Link>
                <span className="text-[14px] xl:text-[16px] text-white font-bold font-poppins transition-colors ease-in-out duration-300">
                  /
                </span>
                <Link
                  href={"tel:+918904737001"}
                  className="text-[14px] xl:text-[16px] text-white font-bold font-poppins hover:text-blue-100 transition-colors ease-in-out duration-300"
                >
                  8904737001
                </Link>
              </div>
              <p className="text-[14px] xl:text-[16px] text-white font-bold font-poppins transition-colors ease-in-out duration-300">
                CET Code: E123
              </p>
              <p className="text-[14px] xl:text-[16px] text-white font-bold font-poppins transition-colors ease-in-out duration-300">
                MBA-B434
              </p>
              <p className="text-[14px] xl:text-[16px] text-white font-bold font-poppins transition-colors ease-in-out duration-300">
                MCA-C649
              </p>
            </div>
            <div className="flex items-center justify-center space-x-6">
              <Link
                href={"/admission"}
                className="text-[14px] xl:text-[16px] text-white font-bold font-poppins hover:text-blue-100 transition-colors ease-in-out duration-300"
              >
                Admission Procedure
              </Link>
              <Link
                href={"https://apply.canaraengineering.in/"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] xl:text-[16px] text-white font-bold font-poppins hover:text-blue-100 transition-colors ease-in-out duration-300"
              >
                Admission Open {new Date().getFullYear()}
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile / Small Screen Marquee View */}
        <div className="flex lg:hidden items-center w-full h-10 border-b border-b-[#1e6fa8] overflow-hidden relative">
          <style jsx>{`
            @keyframes marquee {
              0% { transform: translateX(0%); }
              100% { transform: translateX(-50%); }
            }
            .topbar-marquee {
              display: flex;
              width: max-content;
              animation: marquee 22s linear infinite;
            }
            .topbar-marquee:hover {
              animation-play-state: paused;
            }
          `}</style>
          <div className="topbar-marquee text-xs font-semibold font-poppins whitespace-nowrap flex items-center">
            {/* Set 1 */}
            <div className="flex items-center space-x-4 px-2">
              <Link href="mailto:canarait@gmail.com" className="hover:text-blue-100">Email: canarait@gmail.com</Link>
              <span>•</span>
              <span>Phone: <Link href="tel:+918792727001">+91 8792727001</Link> / <Link href="tel:+918904737001">8904737001</Link></span>
              <span>•</span>
              <span>CET Code: E123</span>
              <span>•</span>
              <span>MCA-C649</span>
              <span>•</span>
              <span>MBA-B434</span>
              <span>•</span>
              <Link href="/admission" className="hover:text-blue-100">Admission Procedure</Link>
              <span>•</span>
              <Link href="https://apply.canaraengineering.in/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-100">Admission Open {new Date().getFullYear()}</Link>
              <span className="pr-4">•</span>
            </div>
            {/* Set 2 (Duplicate for infinite seamless loop) */}
            <div className="flex items-center space-x-4 px-2">
              <Link href="mailto:canarait@gmail.com" className="hover:text-blue-100">Email: canarait@gmail.com</Link>
              <span>•</span>
              <span>Phone: <Link href="tel:+918792727001">+91 8792727001</Link> / <Link href="tel:+918904737001">8904737001</Link></span>
              <span>•</span>
              <span>CET Code: E123</span>
              <span>•</span>
              <span>MCA-C649</span>
              <span>•</span>
              <span>MBA-B434</span>
              <span>•</span>
              <Link href="/admission" className="hover:text-blue-100">Admission Procedure</Link>
              <span>•</span>
              <Link href="https://apply.canaraengineering.in/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-100">Admission Open {new Date().getFullYear()}</Link>
              <span className="pr-4">•</span>
            </div>
          </div>
        </div>
      </section>
      <section className={`bg-white relative transition-all duration-500 ease-in-out border-b-4 border-[#2884CA] border-t-2 border-[#2884CA] shadow-md`}>
        <nav className="py-0 max-w-[95%] mx-auto">
          {/* Desktop Navigation */}
          <div className={`hidden lg:flex items-center justify-between relative ${isMcaOrMba ? "py-4" : "py-7"} lg:py-2 xl:py-3 container-padding`}>
            <div className="flex flex-row items-center relative">
              <Link href={"/"}>
                <Image
                  src={"/svgs/logos/logo.svg"}
                  width={300}
                  height={80}
                  priority
                  alt="logo"
                  onClick={() => {
                    router.push("/");
                  }}
                  className="object-contain cursor-pointer h-16 w-auto"
                />
              </Link>
              {isMcaOrMba && (
                <>
                  <div className="h-16 w-px bg-gray-300 mx-2"></div>
                  <Image
                    src={"/svgs/logos/QE SVG.svg"}
                    width={300}
                    height={80}
                    priority
                    alt="QSpiders logo"
                    className="object-cover h-16 w-[530px] xl:w-[350px]"
                  />
                </>
              )}
            </div>

            {/* Navbar Items */}
            <div>
              <NavbarItems />
            </div>
          </div>

          {/* Mobile / Responsive Navigation */}
          <div className="flex lg:hidden items-center justify-between w-full py-5 px-4 relative">
            {/* Left Corner: 3-Dash Hamburger Menu Button (Opens from Left) */}
            <div className="flex items-center z-20 w-10">
              <button
                onClick={() => {
                  if (setSidebarPosition) setSidebarPosition("left");
                  openSidebar((prev: boolean) => !prev);
                }}
                tabIndex={0}
                role="button"
                aria-label="Open left menu"
                className="text-[#1F2937] hover:text-[#2884CA] cursor-pointer p-1 rounded-lg transition-colors flex items-center justify-center focus:outline-none"
              >
                <svg className="w-6 h-6 stroke-[#1F2937] hover:stroke-[#2884CA]" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="4" y1="6" x2="20" y2="6" />
                  <line x1="4" y1="12" x2="20" y2="12" />
                  <line x1="4" y1="18" x2="20" y2="18" />
                </svg>
              </button>
            </div>

            {/* Center Logo */}
            <div className="flex-1 flex items-center justify-center">
              <Link href={"/"}>
                <Image
                  src={"/svgs/logos/logo.svg"}
                  width={240}
                  height={70}
                  priority
                  alt="Canara logo"
                  onClick={() => {
                    router.push("/");
                  }}
                  className="object-contain cursor-pointer h-12 sm:h-14 w-auto"
                />
              </Link>
            </div>

            {/* Right Corner Menu Button - 3 Vertical Dots (Opens from Right) */}
            <div className="flex items-center justify-end z-20 w-10">
              <button
                onClick={() => {
                  if (setSidebarPosition) setSidebarPosition("right");
                  openSidebar((prev: boolean) => !prev);
                }}
                tabIndex={0}
                role="button"
                aria-label="Toggle right menu"
                className="text-[#1F2937] hover:text-[#2884CA] cursor-pointer p-1 rounded-lg transition-colors flex items-center justify-center focus:outline-none"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="5" r="2" fill="#1F2937" />
                  <circle cx="12" cy="12" r="2" fill="#1F2937" />
                  <circle cx="12" cy="19" r="2" fill="#1F2937" />
                </svg>
              </button>
            </div>
          </div>
        </nav>
      </section>
      {/* First Header */}
    </>
  );
}

export default Navbar;